import styled from 'styled-components'

import { createIcon } from '@blade/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type AntiMevShieldProps = { size?: number; active: boolean } & ClassNameProps

export const AntiMevShield: React.FC<AntiMevShieldProps> = ({
  className,
  size = 16,
  active,
}) => {
  return (
    <StyledIconStyled data-active={active} size={size} className={className} />
  )
}

const ShieldIcon = createIcon(
  <>
    <path
      d="M17.4167 13.5091C17.4167 15.6962 15.2778 17.61 11 19.2503C6.72226 17.61 4.58337 15.6962 4.58337 13.5091C4.58337 11.322 4.58337 8.58804 4.58337 5.30734C7.45815 4.21378 9.59703 3.66699 11 3.66699C12.403 3.66699 14.5419 4.21378 17.4167 5.30734C17.4167 8.58804 17.4167 11.322 17.4167 13.5091Z"
      className="shield-outline"
      strokeLinecap="square"
    />
    <path
      d="M16 13.2105C16 15.0351 14.3333 16.6316 11 18C7.66667 16.6316 6 15.0351 6 13.2105C6 11.386 6 9.10526 6 6.36842C8.24008 5.45614 9.90675 5 11 5C12.0933 5 13.7599 5.45614 16 6.36842C16 9.10526 16 11.386 16 13.2105Z"
      className="shield-dark"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 18C14.3333 16.6316 16 15.0351 16 13.2105V6.36842C13.7599 5.45614 12.0933 5 11 5V18Z"
      className="shield-light"
    />
  </>,
  '0 0 22 22',
)

const StyledIconStyled = styled(ShieldIcon)`
  &[data-active='true'] {
    .shield-dark {
      fill: var(--primary-9);
    }
    .shield-light {
      fill: var(--primary-6);
    }
    .shield-outline {
      stroke: var(--primary-9);
    }
  }
  &[data-active='false'] {
    .shield-dark {
      fill: var(--gray-9);
    }
    .shield-light {
      fill: var(--gray-6);
    }
    .shield-outline {
      stroke: var(--gray-9);
    }
  }
`
